import type { IconProps } from './types';

export const ChevronRightIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M6.84375 2.15625L16.6875 12L6.84375 21.8438" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
